import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { constants } from '@assets/data/constants';


@Component({
  selector: 'app-new-webflow',
  templateUrl: './new-webflow.component.html',
  styleUrls: ['./new-webflow.component.less']
})
export class NewWebflowComponent implements OnInit {
  @Input() webFlowFormVal: any = FormGroup;
  @Input() submitted: any ;
  constants = constants;

  constructor() { }

  ngOnInit(): void {
    this.webFlowForm();
  }

  webFlowForm() {
    this.webFlowFormVal.addControl('uri', new FormControl(null, [Validators.required]));
    this.webFlowFormVal.addControl('environmentSpecific', new FormControl(true));
    this.webFlowFormVal.addControl('threshold', new FormControl(null));
  }
  get f() { return this.webFlowFormVal.controls; }

}